import React, {useState, useEffect, useContext, useRef} from 'react'
import { keyContext } from "../components/KeyContext";
import { useNavigate } from "react-router-dom";
import moment from 'moment'
import FilmWidget from './FilmWidgets';
import { format  } from "date-fns";
import da from "date-fns/locale/da";
import whitekost from '../images/whitekost.png';
import blackkost from '../images/blackkost.png'

function ProgramTable({ show_index,date_length,allEvents,numberOfSal,modalShown,isloading,newDraggedFilm,days,allMovies,eventsEdit, daysEvent,filmWidth,setchosenMovies,chosenMovies,first_start_time,last_end_time,hasProgram,showPrice,showForstype,showPrimaryTkt,showStartEndtime,showInternetOrder, showInternetSalg, showInternetVis}) {


    const {moviesSelected ,eventsChanged, showDropdown,allTicketTypes,setShowFilm,setWaitingModal ,setShowErrorModal,setErrorStatus,setErrorType,setApiLoader,setEventSaveObj,logOut,setErrorNo,setErrorText,modalOpen,draggedMovieId,setDraggedMovieId, draggedFilm, setDraggedFilm,showG,setShowG,eventPushCheck,eventSaveObj,setCall_get_program,setRefno0} = useContext(keyContext)
 
      let filmDivHeight = showPrice === true && showStartEndtime === true && (showPrimaryTkt === true || showForstype === true) ? 86 : 
       ((showPrice === true && showStartEndtime === true) || (showPrice === true && ( showPrimaryTkt === true || showForstype === true) ) || (showStartEndtime === true && ( showPrimaryTkt === true || showForstype === true) ) ) ? 65 : showPrice === true || showStartEndtime === true || showPrimaryTkt === true || showForstype === true ? 45  : 24
    const [draggedId, setDraggedId] = useState();
      let flag = false // flag determines overlap text when api takes more than 2 seconds to reply
      // const [showG,setShowG] = useState(false)
    
      const [duplicateEvent, setDuplicateEvent] = useState(false);
      const [duplicateEvObj, setDuplicateEvObj] = useState({});
      const [x, setX ] = useState(0)
      const [y, setY ] = useState(0)
      const [startTime,setStartTime] = useState([])
      const [dragEnded, setDragEnded] = useState(false)
      const [dragging, setdragging] = useState(false);
      const [showTime,setShowTime] = useState(false)
      const [widgets, setWidgets] = useState([])
      const [chosenTableNo, setChosenTableNo] = useState()
      // const [selectedEvent, setselectedEvent] = useState();
       const [draggedDiv, setDraggedDiv] = useState()
      // const [filmWidth, setFilmWidth] = useState()
      const [theDraggedElm,    setTheDraggedElm]  = useState([])
      // const [draggedMovieId,setDraggedMovieId]  = useState()
      let ge = sessionStorage.getItem('programOrg')
      let orgSelect = ge && ge.split(" ")[ge.split(" ").length - 1]
      // const [theNewdraggedElm, setTheNewdraggedElm] = useState([]);
      const key = sessionStorage.getItem("key");  
      const navigate = useNavigate();
      const [saveFilmEdit, setSaveFilmEdit] = useState(false);
      const [dragProgrammed,   setDragProgrammed] = useState(false)
      
      
         // ---- creating programmed films object ---
let moviesOnDate = Object.assign([],  allMovies)
let moviesPerDay = moviesOnDate.length > allMovies.length ? moviesOnDate : allMovies
if( newDraggedFilm) moviesPerDay.push(newDraggedFilm)
    // copied_events is used for creating a copy of object and for changing the variables in it to be given to event_save later in the code
    let copied_events = JSON.parse(JSON.stringify(allEvents))
  
 

//    let updatedEvents =  copied_events.map(ev => 
//      eventsEdit.find(e => e?.No === ev.No) ? eventsEdit.find(e => e?.No === ev.No) :   ev
// ) 

  //  // updated events are the events which already existed before later changed or not changed
  //  let newlyCreatedEvs = eventsEdit &&  eventsEdit.filter(e => e?.No === 0)          // newly created events which has no event no
    

  //  let mergedEvents = newlyCreatedEvs && [...updatedEvents,  ...newlyCreatedEvs]
        
         
  const selectedDate = days
  
     // ----------STEP MINUTES --------------
  const step_minutes = 5
  
  let eventsPerDay = daysEvent
  //  mergedEvents.filter(e => moment(e.start).format('DD-MM-YYYY') == moment(days).format('DD-MM-YYYY')) 
    eventsPerDay = eventsPerDay.filter(obj => { return obj.movieId !== 0} )  // events med movieID 0 er sortet fra og derfor ikke med i eventsperday
 
  let events_today = eventsEdit.filter(e => moment(e.start).format('DD-MM-YYYY') === moment(selectedDate).format('DD-MM-YYYY')) 
  
  let ProgrammedEvents = []
  let times = []
  let dateTimesArr = []
  let showEndTime = []

    for(let i = 0; i < eventsPerDay.length; i++) {
      if(eventsPerDay[i].movieId > 0) {
        ProgrammedEvents.push({
        eventObject:eventsPerDay[i],
        movieSelected:moviesSelected,
        eventEdit: eventsChanged,
        isOpen:showDropdown,
        index : findLocIndex(eventsPerDay[i]),
        event_No :eventsPerDay[i].No,
        name:   findMovieName(eventsPerDay[i]),
        movieLength:hasMovieLength(eventsPerDay[i]),
        length: findFDuration(eventsPerDay[i]),
        y_axis: calculateY(eventsPerDay[i]),
        x_axis: 0,
        ref_No : eventsPerDay[i].RefNo,
        locationId: findLocationId(eventsPerDay[i]),
        start: moment(eventsPerDay[i].start).format('HH:mm'),     
        end: moment(moment(eventsPerDay[i].start).add(findFDuration(eventsPerDay[i]), 'm').toDate()).format('HH:mm'),
        sal: findLocations(eventsPerDay[i]),
        ArrTypeName: eventsPerDay[i].ArrTypeName,
        webReserveInfo: eventsPerDay[i].WebreserveInfo?.enabled,
        webbuyInfo: eventsPerDay[i].WebbuyInfo?.enabled,
        webshowInfo: eventsPerDay[i].WebshowInfo?.enabled,
        buyEnabled: eventsPerDay[i].BuyEnabled,
        reserveEnabled: eventsPerDay[i].ReserveEnabled,
        numberedSeats:eventsPerDay[i].hasNumberedSeats,
        priceGroups:eventsPerDay[i].PriceGroups,
        tickettypes: findTickettypesName(eventsPerDay[i]),
        ArrTypeNo:eventsPerDay[i].ArrTypeNo,
        UsePriceGroupTemplate:eventsPerDay[i].UsePriceGroupTemplate,
        UseTicketTypeTemplate:eventsPerDay[i].UseTicketTypeTemplate
      })
  
      times.push(moment(eventsPerDay[i].start).format('HH:mm'))
      dateTimesArr.push(localStorage.getItem('sameTimeline')  === "true" ? moment(eventsPerDay[i].start).format('YYYY-MM-DD ')+ first_start_time: moment(eventsPerDay[i].start).format('YYYY-MM-DD HH:mm'))

      showEndTime.push(localStorage.getItem('sameTimeline')  === "true" ? moment(eventsPerDay[i].start).format('YYYY-MM-DD ')+ last_end_time : moment(moment(eventsPerDay[i].start).add(findFDuration(eventsPerDay[i]), 'm').toDate()).format('YYYY-MM-DD HH:mm'))

     
    }
    }
  
       dateTimesArr = dateTimesArr.sort()
       showEndTime  =  showEndTime.sort()


     //---------time calculations below ------------
      const [last, setLast] = useState();
     
       let g = showEndTime[showEndTime.length - 1]
      
       useEffect(() => {
         if(moment(g).format('mm') > '00') {        
           let d = moment(g).add(1, 'hour')         
           setLast(moment(d))
          }
          else 
          setLast(g)
       },[g])

    let timeStamp = []
  //--------DEFAULT START TIME AND DEFAULT END TIME if no events are programmed
    let default_start =  `${moment(selectedDate).format('YYYY-MM-DD')}T${localStorage.getItem('defaultTimeStart')}`
    let default_end   =  `${moment(selectedDate).format('YYYY-MM-DD')}T${localStorage.getItem('defaultTimeEnd')}`
  
    
    let fors_start =  dateTimesArr[0] ? dateTimesArr[0] :  moment(selectedDate).format('YYYY-MM-DD ')+ first_start_time
    if (fors_start < moment(default_start).format('YYYY-MM-DD HH:00')) default_start = moment(fors_start).format('YYYY-MM-DD HH:00')
  
    let fors_end   = showEndTime[showEndTime.length - 1] ?   showEndTime[showEndTime.length - 1] :  moment(selectedDate).format('YYYY-MM-DD ')+ last_end_time 
    // ? last_end_time : localStorage.getItem('defaultTimeEnd')
     if(hasProgram.length === 0) {
      fors_end = moment(selectedDate).format('YYYY-MM-DD ')+localStorage.getItem('defaultTimeEnd')
     }
    if (fors_end > moment(default_end).format('YYYY-MM-DD HH:00')) default_end = moment(fors_end).add(1,'hour').format('YYYY-MM-DD HH:00')

   const dt_start = Date.parse(default_start)
    // eventsPerDay && eventsPerDay.length === 0 ? Date.parse(default_start) : Date.parse(fors_start)
    const dt_end = Date.parse (default_end)
    // eventsPerDay && eventsPerDay.length === 0 ? Date.parse (default_end) : Date.parse(last)
   
  
    let te =   moment(dt_end).format('HH')
     eventsPerDay && eventsPerDay.length === 0 ? moment(dt_end).format('HH') :  moment(last).format('HH')
   
         
  
  let t_start =   moment(dt_start).format('HH')
  let t_end = moment(dt_end).format('HH') == '00'  ? '24' 
  :  moment(dt_end).format('HH') == '01' ? '25'
  :  moment(dt_end).format('HH') == '02' ? '26'
  :  moment(dt_end).format('HH') == '03' ? '27'
  :  moment(dt_end).format('HH')
   
      for (let index = t_start; index < t_end;  index ++) {
  
             timeStamp.push(index)
    
      }
     
     let pixelWidthPerMin = document.getElementById('program_table'+show_index)?.clientWidth/(timeStamp.length*60).toFixed(2)



     for(let i = 0; i <eventsPerDay.length; i++) {
        
           if(eventsPerDay[i].movieId > 0 ) {
         //ProgrammedEvents[i].x_axis = calculateX(eventsPerDay[i], dateTimesArr[0], showEndTime[showEndTime.length-1])
         ProgrammedEvents[i].x_axis = calculateX(eventsPerDay[i], Date.parse(moment(default_start).format('yyyy-MM-DD HH:00')), Date.parse(moment(default_end).format('yyyy-MM-DD HH:00')))
         }
         
     
       }

        function calculateX (e, fors_start, fors_end) {
            
             let table_width = document.getElementById('program_table'+show_index)?.clientWidth
           
             fors_start = Date.parse(moment(fors_start).format('yyyy-MM-DD HH:00'))    
             
             if (moment(fors_end).format('mm') > '00') fors_end = moment(fors_end).add(1,'hours')
       
             fors_end = Date.parse(moment(fors_end).format("yyyy-MM-DD HH:00"))
       
             let total_minutes = (fors_end - fors_start)/60000
             let pixelsprminute = table_width / total_minutes
              
             let start_minute_count = (moment(e.start) - fors_start)/60000
             let startx = Math.round(start_minute_count * pixelsprminute)
                     
             return startx
           }

  function findLocIndex (i) {
  let salIndex
  for(let x=0;x<numberOfSal.length;x++)
  {
     if (numberOfSal[x].No === i.locationId)
     {
       salIndex=x
       break;
     }
  }
    return salIndex
}

function findTickettypesName (e) {

  let name 
  allTicketTypes.map((type) => {
    if(e.ArrTypeNo === type.No) {
      name = type.Name
    }
  })
  return name

}

  function findMovieName (i) {
    let name 
    moviesPerDay.map((movie) => {
          
            if(i.movieId === movie.No) {
              name= movie.name
            }         
     })
     return name
  }

   function hasMovieLength (i) { 
    let hasLength = false
    moviesPerDay.map((movie) => {
     
        if (movie.No === i.movieId) {
         
          movie.length > 0 ? hasLength = true: hasLength = false
        }
      })
      return hasLength
  }

  function findFDuration (i) {
      let length 
      allMovies.map((movie) => {
        if (movie.No === i.movieId) {
          length = movie.length
        }
      })
      return length > 0 ? length : 120   // if film does not have any length then it should be by default 120 (in minutes) 2 hours by default
  }

 function calculateY (e) {
      let salIndex
     
      for(let x=0;x<numberOfSal.length;x++)
      {
       
         if (numberOfSal[x].No === e.locationId)
         {
           salIndex=x
           break;
         }
      } 
     
      let rowheight = (document.getElementById('t_body'+show_index)?.clientHeight/numberOfSal.length)
    
      let y =  52 + (salIndex * filmDivHeight)
    
   return Math.round(y)
   
    }
  
function findLocationId (i) {
    let id 
    allMovies.map((m) => {
      numberOfSal.map((s) => {

        if(s.No === i.locationId && m.No === i.movieId) {
        
           id = s.No
        }
       })
    })
    return id
}

  function findLocations (i) {
    
    let sal
         moviesPerDay.map((m) => {
          numberOfSal.map((s) => {

            if(s.No === i.locationId && m.No === i.movieId) {
            
               sal = s.name
            }
           })
        })
        return sal
  }

  
 function calculateYax (e) {

  let tbodyHeight = document.getElementById('t_body'+show_index).clientHeight
  let theadHeight = document.getElementById('t_head'+show_index).clientHeight
  let salHeight = tbodyHeight / numberOfSal.length
  let cY = e.clientY - (document.getElementById('program_table'+show_index).getBoundingClientRect().y+theadHeight+3)
  cY < 0 ? cY = 0 : (cY > tbodyHeight? cY = tbodyHeight : cY = cY)
  
  let snap_y = 0
  for (let index = 0; index < tbodyHeight; index= index + salHeight) {
      if(e.clientY < (document.getElementById('program_table'+show_index)?.getBoundingClientRect().y+theadHeight+3+(index+salHeight))) {
         if(snap_y == 0) {
            snap_y = index + 3 + theadHeight
        
         }
    }
    
  }
  if (snap_y == 0) 
  {
      snap_y = (theadHeight+3 +tbodyHeight) - salHeight
      
  }

  return snap_y
}

const addMinutes = (dateString, minutes) => {
  const date = new Date(dateString);
  date.setMinutes(date.getMinutes() + minutes);

  // Return in YYYY-MM-DDTHH:mm:ss format
  return date.toISOString().slice(0, 19);
};

 function draggingDiv(e,event) {

   const img = new Image()
         img.src = ''
        e.dataTransfer.setDragImage(img, 0,0)

   if (e.ctrlKey || e.altKey) {
   
      let new_event = Object.assign({}, event)
   
      new_event.eventObject.RefNo = 0
      new_event.eventObject.No = 0
  
      e.target = new_event
     
       setDuplicateEvent(true)
       setDuplicateEvObj(new_event.eventObject)
            }
   else  {
     setDuplicateEvent(false)
   }
 }

function divClicked (e, event) {

  setDraggedDiv(e.target)
  setDraggedId(event.event_No > 0 ? event.event_No :  event.ref_No)
  setTheDraggedElm(event)
   mouse_x_offset = e.clientX - event.x_axis - document.getElementById('program_table'+show_index).getBoundingClientRect().x 
  setMouseOffset(mouse_x_offset)
  // setselectedEvent(event)

}

//-------- following function runs when the existing film-show div is moved ----------
function dragExisting (e,event) {

  setdragging(true)
  setDragProgrammed(true)
  
  let theadHeight = document.getElementById('t_head'+show_index).clientHeight

  let sal_y = calculateYax(e)

  let [snap_to_x, snap_to_x_before ]  = calculateXaxis(e, event)
  
   let start_time = moment( Date.parse(moment(dt_start).format('YYYY-MM-DD HH')+':00'))
   .add(Math.round(snap_to_x_before )*step_minutes, 'm').toDate();

   let end_time = moment(start_time).add(event.length, 'm').toDate();
    event.start = moment(start_time).format('HH:mm')  // overriding start time of existing with dragged
 
    event.end   = moment(end_time).format('HH:mm')
    e.target.style.left = snap_to_x < 0 ? 0+'px' :snap_to_x  +'px'  // moves the dragged div in x-axis
 
  

  e.target.style.top = sal_y +'px' // moving the dragged div in y-axis
  let sal_index = (sal_y-(theadHeight+3))/filmDivHeight

 let bgColor= sal_index === 0 || sal_index === 10 || sal_index === 20 ? sal1Color 
 : sal_index === 1 || sal_index === 11 || sal_index === 21 ? sal2Color 
 : sal_index === 2 || sal_index === 12 || sal_index === 22 ? sal3Color 
 : sal_index === 3 || sal_index === 13 || sal_index === 23 ? sal4Color 
 : sal_index === 4 || sal_index === 14 || sal_index === 24 ? sal5Color
 : sal_index === 5 || sal_index === 15 || sal_index === 25 ? sal6Color 
 : sal_index === 6 || sal_index === 16 || sal_index === 26 ? sal7Color 
 : sal_index === 7 || sal_index === 17 || sal_index === 27 ? sal8Color 
 : sal_index === 8 || sal_index === 18 || sal_index === 28 ? sal9Color 
 : sal_index === 9 || sal_index === 19 || sal_index === 29? sal10Color : ''

  event.index = sal_index  //overriding the index of existing with dragged
   e.target.style.background =  bgColor

   return event
 }

let mouse_x_offset = 0
const [mouseOffset, setMouseOffset] = useState(0);

 function calculateXaxis (e) {


  let mouse_x =  Math.floor( e.clientX - document.getElementById('program_table'+show_index).getBoundingClientRect().x )
  let timestamp_start = moment(Date.parse(moment(dt_start).format('YYYY-MM-DD HH')+':00'))._i
  let timestamp_end   = moment(Date.parse(moment(dt_end).format('YYYY-MM-DD HH')+':00'))._i
  
  let table_width   = document.getElementById('program_table'+show_index).clientWidth
  let total_minutes = (timestamp_end - timestamp_start)/60000
  
  let time_steps    = total_minutes / step_minutes
  let pixelPrStep   = table_width / time_steps;
  let rest_x        = mouse_x % pixelPrStep
  let snap_to_x_before = ((mouse_x - rest_x - mouseOffset) / pixelPrStep)
  let snap_to_x     = Math.round(snap_to_x_before * pixelPrStep)
  
    return [snap_to_x , snap_to_x_before, ]

 }

// let all_days_program = []

 const [items, setItems] = useState();

 

      
let updateProgram =  ProgrammedEvents.map((pro) => {
      let refNo = pro.ref_No
      let eventNo = pro.event_No
      let draggedNo = dragProgrammed === true && theDraggedElm.event_No
    
  if(eventNo === draggedNo && pro.name === theDraggedElm.name && refNo === theDraggedElm.ref_No ) {
    return {...pro, index: theDraggedElm.index,sal :numberOfSal[theDraggedElm.index].name, start: theDraggedElm.start, end:theDraggedElm.end,  }
  }
  return pro
  
  })

 
const toggleMovie = (array, newItem) => {
  const exists = array.some(
    item => item.event_No === newItem.event_No && item.ref_No === newItem.ref_No
  );

  if (exists) {
    // Remove item
    return array.filter(
      item => !(item.event_No === newItem.event_No && item.ref_No === newItem.ref_No)
    );
  } else {
    // Add item
    return [...array, newItem];
  }
};
 const handleToggle = (ev) => {
      setchosenMovies( prevItems => toggleMovie(prevItems,ev))

        };
        


//-------------colors  indicates the sal
let sal1Color  = '#DBE754';
let sal1Color2 = '#f5fabf';
let sal1Color3 = 'rgba(219,231,84, 0.3)';
let aktivColor1= '#ADB920';
let sal1popbg2 = '#FBFFCF';
let sal1popbg3 = '#FCFFDE';
let sal1CleanColor = '#C1CE1D'

let sal2Color  = '#adb0ff'; 
let sal2Color2 = '#e5e6fb';
let sal2Color3 = 'rgba(173,176,255, 0.25)';
let aktivColor2= '#9498F6';
let sal2popbg2 ='#EBECFC';
let sal2popbg3 ='#F6F6FF'
let sal2CleanColor = '#8589EE'

let sal3Color  = '#ff9b2f';
let sal3Color2 = '#feebd7';
let sal3Color3 = 'rgba(225,166,47, 0.2)';
let aktivColor3= '#FF9B2F';
let sal3popbg2 = '#FEF1E2'
let sal3popbg3 = '#FEF5EC'
let sal3CleanColor ='#EF840F'

let sal4Color  = '#a9e5ff';
let sal4Color2 = '#def5ff';
let sal4Color3 = 'rgba(169,229,255, 0.3)';
let aktivColor4= '#37B7EE';
let sal4popbg2 = '#EBF9FF'
let sal4popbg3 = '#F5FCFF'
let sal4CleanColor = '#83CAE8'

let sal5Color  = '#7ee56d';
let sal5Color2 = '#c9fbc0';
let sal5Color3 = 'rgba(126,228,109, 0.25)';
let aktivColor5= '#3EBB29';
let sal5popbg2 = '#D8F7D2'
let sal5popbg3 = '#E5FAE1'
let sal5CleanColor = '#5ACC48'

let sal6Color  = '#f15f56'
let sal6Color2 = '#FADEDD'
let sal6Color3 = 'rgba(241, 95, 86, 0.15)'
let aktivColor6= '#F7574D';
let sal6popbg2 = '#FFEBEB'
let sal6popbg3  ='#FFF3F2'

let sal7Color  = '#3bc4a0'
let sal7Color2 = '#dbf7f0'
let sal7Color3 = 'rgba(59, 196, 160, 0.3)'
let aktivColor7= '#23A985';
let sal7popbg2 = '#E6FAF5'
let sal7popbg3 = '#F5FFFC'

let sal8Color  = '#f5c645'
let sal8Color2 = '#f7edd2'
let sal8Color3 = 'rgba(245, 198, 69, 0.25)'
let aktivColor8= '#DFA60A';
let sal8popbg2 = '#F5EFDC'
let sal8popbg3 = '#F9F5E9'

let sal9Color  = '#6978ff'
let sal9Color2 = '#e4e7ff'
let sal9Color3 = 'rgba(105, 120, 255, 0.2)'
let aktivColor9= '#6978FF';
let sal9popbg2 = '#F0F0FF'
let sal9popbg3 = '#F6F6FF'

let sal10Color = '#2c6b0f'
let sal10Color2= '#caf1b8'
let sal10Color3= 'rgba(44, 107, 15, 0.1)'
let aktivColor10='#2C6B0F';
let sal10popbg2 ='#D8FAC8'
let sal10popbg3 ='#E5FFD9'

 const [internetorderflag, setInternetorderflag] = useState()
 const [internetsellflag,   setInternetsellflag] = useState()
 const [intershowflag,         setIntershowflag] = useState()
 const [sellticketflag,       setSellticketflag] = useState()
 const [orderticketflag,     setOrderticketflag] = useState()

let cleaning_time = localStorage.getItem('cleaningTime')
function hexToRgba(hex, opacity) {
  hex = hex.replace('#', '');

  const r = parseInt(hex.substring(0,2), 16);
  const g = parseInt(hex.substring(2,4), 16);
  const b = parseInt(hex.substring(4,6), 16);

  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
}

  //  console.log(updateProgram)
       // generating programmed div which is shown in the table
function programmedFilms() {
      let pf = []
      //  let the = updatePro?.length ? updatePro : updateProgram 
       updateProgram.forEach( (event) => {
      let checking_no = event.event_No > 0 ? event.event_No :  event.ref_No

        let bgColor = event.index === 0 || event.index === 10 || event.index === 20 ? sal1Color
        : event.index === 1 || event.index === 11 || event.index === 21 ? sal2Color 
        : event.index === 2 || event.index === 12 || event.index === 22 ? sal3Color 
        : event.index === 3 || event.index === 13 || event.index === 23 ? sal4Color 
        : event.index === 4 || event.index === 14 || event.index === 24 ? sal5Color 
        : event.index === 5 || event.index === 15 || event.index === 25 ? sal6Color 
        : event.index === 6 || event.index === 16 || event.index === 26 ? sal7Color 
        : event.index === 7 || event.index === 17 || event.index === 27 ? sal8Color 
        : event.index === 8 || event.index === 18 || event.index === 28 ? sal9Color 
        : event.index === 9 || event.index === 19 || event.index === 29 ? sal10Color  : ''
        pf.push( 
         
            
          <div  
          //className='draggable'
          onMouseDown={ (e) => divClicked (e, event)} 
           draggable={ modalOpen === false  ? 'true': 'false'} 
           id={event.id} 
         //  onDrag={(e) => dragExisting(e,event)} 
           onDragStart={(e) => draggingDiv(e,event)} 

            style={{position:'absolute',
              top:`${ y && draggedId ===  checking_no ? y : event.y_axis}px`,
             left:`${ x && draggedId ===  checking_no ? x : event.x_axis}px`,
            width:`${(pixelWidthPerMin*event.length).toString().split(".")[0] + 'px' }`, 
            
            background:event.eventObject.DeleteEvent === 1 ? hexToRgba(bgColor, 0.3) : bgColor,
           
            borderRadius:'4px',
          
            }}>
         
             
            <FilmWidget showInternetOrder={showInternetOrder} showInternetVis={showInternetVis} chosenMovies={chosenMovies} setchosenMovies={setchosenMovies}
     showInternetSalg={showInternetSalg} filmDivHeight={filmDivHeight} showPrice={showPrice} showForstype={showForstype} showPrimaryTkt={showPrimaryTkt} showStartEndtime={showStartEndtime} onToggle={handleToggle} all_events={copied_events} daysEvent={updateProgram} eventEdited={eventsEdit.find(e => { return e.No === event.event_No})}  arrtypename={event.ArrTypeName} film={event.name} 
            salNr={event.sal} eventsEdit={events_today}  event_no={event.event_No > 0 ? event.event_No : event.ref_No} ref_no ={event.ref_No}
             saveEditBtn={saveFilmEdit} theWidth={(pixelWidthPerMin*event.length).toString().split(".")[0]} 
             theEvent={event}  
            //  editedevent={editedEvents.find(e => {return e.event_No === event.event_No})}
              price={event.priceGroups?.length === 1 ?  event.priceGroups[0]?.Price : event.priceGroups?.length === 2 ? event.priceGroups[0].Price +'-'+  event.priceGroups[1].Price: '0'}  theDraggedElm={theDraggedElm} dragging={dragging}
              adTrailer = {event.eventObject.AdvertisementTrailer}
              movieLength={event.length}
              webresinfo={event.webReserveInfo} 
              webbuyinfo={event.webbuyInfo} 
              webshowinfo={event.webshowInfo} 
              buyenabled={event.buyEnabled} 
              resenabled={event.reserveEnabled} 
              numbered={event.numberedSeats}
              internetOrderAll={saveFilmEdit  && internetorderflag } 
              internetSellAll ={saveFilmEdit  && internetsellflag } 
              internetShowAll ={saveFilmEdit  && intershowflag} 
              ticketSellAll   ={saveFilmEdit  && sellticketflag}
              ticketOrderAll  ={saveFilmEdit  && orderticketflag} 
              end_Time={event.end} start_Time={event.start}  
              movieNameColor={    
                  event.index === 0 || event.index === 10 || event.index === 20 ? '#46484c' 
                : event.index === 1 || event.index === 11 || event.index === 21 ? '#fff'
                : event.index === 2 || event.index === 12 || event.index === 22 ? '#fff' 
                : event.index === 3 || event.index === 13 || event.index === 23 ? '#46484c'
                : event.index === 4 || event.index === 14 || event.index === 24 ? '#46484c' 
                : event.index === 5 || event.index === 15 || event.index === 25 ? '#fff' 
                : event.index === 6 || event.index === 16 || event.index === 26 ? '#fff' 
                : event.index === 7 || event.index === 17 || event.index === 27 ? '#46484c' 
                : event.index === 8 || event.index === 18 || event.index === 28 ? '#fff' 
                : event.index === 9 || event.index === 19 || event.index === 29 ? '#fff' :  ''}
            showTime={showTime && startTime}
             cleaning_bgColor= {
               event.index === 0 || event.index === 10 || event.index === 20 ? sal1CleanColor 
              : event.index === 1 || event.index === 11 || event.index === 21 ? sal2CleanColor
              : event.index === 2 || event.index === 12 || event.index === 22 ? sal3CleanColor 
              : event.index === 3 || event.index === 13 || event.index === 23 ? sal4CleanColor 
              : event.index === 4 || event.index === 14 || event.index === 24 ? sal5CleanColor
              : ''
             }
            extendedBackColor= 
            {   event.index === 0 || event.index === 10 || event.index === 20 ? sal1Color2 
              : event.index === 1 || event.index === 11 || event.index === 21 ? sal2Color2
              : event.index === 2 || event.index === 12 || event.index === 22 ? sal3Color2 
              : event.index === 3 || event.index === 13 || event.index === 23 ? sal4Color2 
              : event.index === 4 || event.index === 14 || event.index === 24 ? sal5Color2 
              : event.index === 5 || event.index === 15 || event.index === 25 ? sal6Color2 
              : event.index === 6 || event.index === 16 || event.index === 26 ? sal7Color2 
              : event.index === 7 || event.index === 17 || event.index === 27 ? sal8Color2 
              : event.index === 8 || event.index === 18 || event.index === 28 ? sal9Color2 
              : event.index === 9 || event.index === 19 || event.index === 29 ? sal10Color2 :  ''} 

            timelineBackColor = {
               event.index === 0 || event.index === 10  || event.index === 20 ? sal1Color
             : event.index === 1 || event.index === 11 || event.index === 21 ? sal2Color 
             : event.index === 2 || event.index === 12 || event.index === 22 ? sal3Color 
             : event.index === 3 || event.index === 13 || event.index === 23 ? sal4Color 
             : event.index === 4 || event.index === 14 || event.index === 24 ? sal5Color 
             : event.index === 5 || event.index === 15 || event.index === 25 ? sal6Color 
             : event.index === 6 || event.index === 16 || event.index === 26 ? sal7Color 
             : event.index === 7 || event.index === 17 || event.index === 27 ? sal8Color 
             : event.index === 8 || event.index === 18 || event.index === 28 ? sal9Color 
             : event.index === 9 || event.index === 19 || event.index === 29 ? sal10Color  : '' 
            }

            priceDivBackColor={
                event.index === 0 || event.index === 10 || event.index === 20 ? sal1Color3 
              : event.index === 1 || event.index === 11 || event.index === 21 ? sal2Color3 
              : event.index === 2 || event.index === 12 || event.index === 22 ? sal3Color3 
              : event.index === 3 || event.index === 13 || event.index === 23 ? sal4Color3 
              : event.index === 4 || event.index === 14 || event.index === 24 ? sal5Color3 
              : event.index === 5 || event.index === 15 || event.index === 25 ? sal6Color3 
              : event.index === 6 || event.index === 16 || event.index === 26 ? sal7Color3 
              : event.index === 7 || event.index === 17 || event.index === 27 ? sal8Color3 
              : event.index === 8 || event.index === 18 || event.index === 28 ? sal9Color3 
              : event.index === 9 || event.index === 19 || event.index === 29 ? sal10Color3  : '' }

              activeColor={
                  event.index === 0 || event.index === 10 || event.index === 20 ? aktivColor1
                : event.index === 1 || event.index === 11 || event.index === 21 ? aktivColor2 
                : event.index === 2 || event.index === 12 || event.index === 22 ? aktivColor3
                : event.index === 3 || event.index === 13 || event.index === 23 ? aktivColor4
                : event.index === 4 || event.index === 14 || event.index === 24 ? aktivColor5
                : event.index === 5 || event.index === 15 || event.index === 25 ? aktivColor6
                : event.index === 6 || event.index === 16 || event.index === 26 ? aktivColor7
                : event.index === 7 || event.index === 17 || event.index === 27 ? aktivColor8
                : event.index === 8 || event.index === 18 || event.index === 28 ? aktivColor9
                : event.index === 9 || event.index === 19 || event.index === 29 ? aktivColor10  : ''
              }

              popupbg2={
                  event.index === 0 || event.index === 10 || event.index === 20 ? sal1popbg2
                : event.index === 1 || event.index === 11 || event.index === 21 ? sal2popbg2 
                : event.index === 2 || event.index === 12 || event.index === 22 ? sal3popbg2
                : event.index === 3 || event.index === 13 || event.index === 23 ? sal4popbg2
                : event.index === 4 || event.index === 14 || event.index === 24 ? sal5popbg2
                : event.index === 5 || event.index === 15 || event.index === 25 ? sal6popbg2
                : event.index === 6 || event.index === 16 || event.index === 26 ? sal7popbg2
                : event.index === 7 || event.index === 17 || event.index === 27 ? sal8popbg2
                : event.index === 8 || event.index === 18 || event.index === 28 ? sal9popbg2
                : event.index === 9 || event.index === 19 || event.index === 29 ? sal10popbg2  : ''
              }

              popupbg3 = {
                  event.index === 0 || event.index === 10 || event.index === 20 ? sal1popbg3
                : event.index === 1 || event.index === 11 || event.index === 21 ? sal2popbg3
                : event.index === 2 || event.index === 12 || event.index === 22 ? sal3popbg3
                : event.index === 3 || event.index === 13 || event.index === 23 ? sal4popbg3
                : event.index === 4 || event.index === 14 || event.index === 24 ? sal5popbg3
                : event.index === 5 || event.index === 15 || event.index === 25 ? sal6popbg3
                : event.index === 6 || event.index === 16 || event.index === 26 ? sal7popbg3
                : event.index === 7 || event.index === 17 || event.index === 27 ? sal8popbg3
                : event.index === 8 || event.index === 18 || event.index === 28 ? sal9popbg3
                : event.index === 9 || event.index === 19 || event.index === 29 ? sal10popbg3  : ''
              }

            /> 

            { (pixelWidthPerMin*cleaning_time).toString().split(".")[0] > 0 && 
               <div style={{position:'absolute',height:filmDivHeight+'px',alignContent:'center',
                backgroundColor:  event.index === 0 || event.index === 10 || event.index === 20 ? sal1CleanColor 
              : event.index === 1 || event.index === 11 || event.index === 21 ? sal2CleanColor
              : event.index === 2 || event.index === 12 || event.index === 22 ? sal3CleanColor 
              : event.index === 3 || event.index === 13 || event.index === 23 ? sal4CleanColor 
              : event.index === 4 || event.index === 14 || event.index === 24 ? sal5CleanColor
              : ''
                ,borderRadius:'5px',top:'0px',textAlign:'center',
               left:`${(pixelWidthPerMin*event.length).toString().split(".")[0] + 'px' }`,
                width:`${(pixelWidthPerMin*cleaning_time).toString().split(".")[0] + 'px' }`,}}>
                  <img src={
 event.index === 0 || event.index === 10 || event.index === 20 ? blackkost
                : event.index === 1 || event.index === 11 || event.index === 21 ? whitekost
                : event.index === 2 || event.index === 12 || event.index === 22 ? whitekost
                : event.index === 3 || event.index === 13 || event.index === 23 ? blackkost
                : event.index === 4 || event.index === 14 || event.index === 24 ? blackkost
                : event.index === 5 || event.index === 15 || event.index === 25 ? whitekost
                : event.index === 6 || event.index === 16 || event.index === 26 ? whitekost 
                : event.index === 7 || event.index === 17 || event.index === 27 ? blackkost 
                : event.index === 8 || event.index === 18 || event.index === 28 ? whitekost
                : event.index === 9 || event.index === 19 || event.index === 29 ? whitekost :  ''
                    } alt='cleaning-icon'/>
                 
                  </div>
            }
           </div>
        
        ) 
      })
      return pf
}


 const program = programmedFilms()

//------------runs when div is dragged over the table area ---------------
function handleDragOver(e) {

   setShowFilm(false)
  //  setDragStarted(true)
    e.preventDefault()   
    setChosenTableNo(e.target.id ? e.target.id :e.target.parentElement.parentElement.id)
    
   // e.dataTransfer.types.length  && draggedFilm  ? setShowG(true) : setShowG(false) 
   
    let sal_y = calculateYax(e)
    setY(sal_y) 
   //-----------formula for obtaining x axis--------
    const [snap_to_x, snap_to_x_before ]  = calculateXaxis(e)
    let start_time = moment(Date.parse(moment(dt_start).format('YYYY-MM-DD HH')+':00')).add(Math.round(snap_to_x_before)*step_minutes, 'm').toDate()
   
    setStartTime(moment(start_time).format('YYYY-MM-DD  HH:mm'))
    // let end_time = moment(start_time).add(filmWidth, 'm').toDate();
    setX(snap_to_x ) 
   
  
   if(e.dataTransfer.types.length  && draggedFilm) {
     setShowG(true)
    }
     else {    // if existing div is dragged -doing the following
           setShowG(false) 
           setdragging(true)
           setDragProgrammed(true)
            let theadHeight = document.getElementById('t_head'+show_index).clientHeight

  let sal_y = calculateYax(e)

  let [snap_to_x, snap_to_x_before ]  = calculateXaxis(e, theDraggedElm)
  
   let start_time = moment( Date.parse(moment(dt_start).format('YYYY-MM-DD HH')+':00'))
   .add(Math.round(snap_to_x_before )*step_minutes, 'm').toDate();

   let end_time = moment(start_time).add(theDraggedElm.length, 'm').toDate();
    theDraggedElm.start = moment(start_time).format('HH:mm')  // overriding start time of existing with dragged
 
    theDraggedElm.end   = moment(end_time).format('HH:mm')
    draggedDiv.style.left = snap_to_x < 0 ? 0+'px' :snap_to_x  +'px'  // moves the dragged div in x-axis
 
  

  draggedDiv.style.top = sal_y +'px' // moving the dragged div in y-axis
  let sal_index = (sal_y-(theadHeight+3))/filmDivHeight

//  let bgColor= sal_index === 0 || sal_index === 10 || sal_index === 20 ? sal1Color 
//  : sal_index === 1 || sal_index === 11 || sal_index === 21 ? sal2Color 
//  : sal_index === 2 || sal_index === 12 || sal_index === 22 ? sal3Color 
//  : sal_index === 3 || sal_index === 13 || sal_index === 23 ? sal4Color 
//  : sal_index === 4 || sal_index === 14 || sal_index === 24 ? sal5Color
//  : sal_index === 5 || sal_index === 15 || sal_index === 25 ? sal6Color 
//  : sal_index === 6 || sal_index === 16 || sal_index === 26 ? sal7Color 
//  : sal_index === 7 || sal_index === 17 || sal_index === 27 ? sal8Color 
//  : sal_index === 8 || sal_index === 18 || sal_index === 28 ? sal9Color 
//  : sal_index === 9 || sal_index === 19 || sal_index === 29? sal10Color : ''

  theDraggedElm.index = sal_index  //overriding the index of existing with dragged
  //  e.target.style.background =  bgColor
      }
  }

//-------- runs when film div is dropped on table-----------------
  function handleOnDrop (e) {
   
   setDragEnded(true)
   setdragging(false)
   setShowTime(false)
   //let tbodyHeight = document.getElementById('t_body').clientHeight
  let theadHeight = document.getElementById( 't_head'+show_index).clientHeight
  
   const widgetType = e.dataTransfer.getData('widgetType') 
   widgetType && setWidgets([...widgets, widgetType]) 
  //-----------formula for obtaining Y-AXIS--------------
   let sal_y = calculateYax(e)
   let sal_index = (sal_y - (theadHeight+3))/filmDivHeight

   let [snap_to_x, snap_to_x_before ]  = calculateXaxis(e)

  //------------saving the start time of particular film---------
 
  let start_time = moment(Date.parse(moment(dt_start).format('YYYY-MM-DD HH')+':00')).add(Math.round(snap_to_x_before)*step_minutes, 'm').toDate();

//  setShowStartTimeArr([...showStartTimeArr, moment(start_time).format('YYYY-MM-DD HH:mm')])
 
  let end_time = moment(start_time).add(filmWidth, 'm').toDate();

  let newTimeStart = moment(selectedDate).format('YYYY-MM-DD')+'T'+theDraggedElm?.start+':00'

   let new_event_start =duplicateEvent === true && duplicateEvObj && addMinutes(duplicateEvObj.start,30)
   duplicateEvObj.start = new_event_start

  let theEvent
  draggedMovieId > 0 ? theEvent = {   //  new dragged event
  movieId: draggedMovieId,
  No: 0,
  RefNo:0,
  start:  moment(start_time).format('YYYY-MM-DD HH:mm'),
  end: moment(end_time).format('YYYY-MM-DD HH:mm'),
  locationId:  numberOfSal[sal_index].No,
  OrgNo: orgSelect,
  AdvertisementTrailer  : localStorage.getItem('adTrailerTime')  // setting advertisementTrailer when creating new show
  // allowOverlap: allowOverlap === 'true' ? 1  : 0,
} 
: duplicateEvent === true && duplicateEvObj ? theEvent = duplicateEvObj
: theEvent = eventsPerDay.find(e => {   // existing event
  if( e.No ===  theDraggedElm.event_No && theDraggedElm.ref_No === e.RefNo) {
       e.start = newTimeStart
      
       
     return  e
  }
})

     let ev = theEvent
   
      //  draggedMovieId > 0 ? ev.start = moment(start_time).format('YYYY-MM-DD HH:mm') : ev.start = newTimeStart      // rewriting the start time
     ev.locationId = numberOfSal[sal_index].No
   
     let draggedEv = updateProgram.find((event) => { return event.event_No === ev.No && event.event_No !== 0})
     let newDraggedEv =  Object.assign({},ev)
     
      newDraggedEv.start = moment(newDraggedEv.start).format('HH:mm')
      newDraggedEv.end = moment(newDraggedEv.end).format('HH:mm')
  
  
//-----EVENT SAVE api call----//


    ev.AllowOverlap = 1 
    setWaitingModal(true)
     setShowG(false)

  fetch(`https://biograf.ebillet.dk/systemnative/report.asmx/man_event_save` ,{
        method: "POST",      
       headers: {
        'ebilletToken': "RGV0IGVyIGVuIGthdCBvZyBpa2tlIGVuIGdyaXM=",
        'Content-Type':  'application/x-www-form-urlencoded',      
       },
       body:`Key=${key}&eventdata=${JSON.stringify(ev)}` 
   })
   .then(res =>  { 
        flag =  true
        if(res.status === 200) {
          return   res.json() 
        }
        else {
          setShowErrorModal(true)
          setErrorStatus(res.status)
          setErrorType(res.type)       
        }   
      })
   .then(result => { 
     setWaitingModal(false)
     setApiLoader(false)
     
     if(result.Result === 1) { 
         setEventSaveObj(result) 
         setCall_get_program(result)
         setDraggedMovieId('')
         setDraggedFilm('')
     }
      else if (result.Result === 0) {
           // log out
           logOut()
           navigate('/')         
         }
          else if(result.Result === -1) {    
            eventPushCheck()
          }
      else {
        setShowErrorModal(true)
        setErrorNo(result.Result)
        setErrorText(result.ErrorDescription)
          if(ev.RefNo === 0 ) {
           setRefno0(true)  
           }

      }
 })
     setTimeout(function () {
          if(flag === false) {       
            setApiLoader(true)             
          } 
         }, 2000)

         if(duplicateEvent === true ) window.location.reload() // reloading after making a duplicate of existing event
         setX(0)
         setY(0)
  }

   moment.updateLocale("da", {
      weekdays: "SØN_MAN_TIR_ONS_TOR_FRE_LØR".split("_"),
    });
    

//  let date =  moment(selectedDate).locale("da").format("dddd")+' ' + format(selectedDate, "d. ") +' ' + moment(selectedDate).locale("da").format("MMM")

  return (
    <div style={{position:'relative',
   // width:'1682px'
    }}>
     {/* {allEvents.length ? <p style={{margin:0,fontWeight:900}}>{date} </p> : ''}  */}
    
   
               
        <div style={{border:'1px ', width:'100%',   padding: '0', position:'relative',display:'flex'}}  
          onDragOver={(e) => handleDragOver(e)} 
          onDrop={(e)=> {handleOnDrop(e)}} 
         >
           {allEvents.length ?
          <div className='date_div'>{allEvents.length ? <p style={{margin:0,fontWeight:900,fontSize:'14px',lineHeight:'14px'}}>{moment(selectedDate).locale("da").format("dddd")+' ' + format(selectedDate, "d. ") +' ' } </p> : ''} <p style={{fontSize:'10px',fontWeight:900,margin:0}}>{ moment(selectedDate).locale("da").format("MMM.") }</p>
          <p style={{margin:0,fontWeight:900,fontSize:'10px'}}>{moment(selectedDate).format('YYYY')}</p></div>
           : ''} 
           <div  className='salContainer' style={{height:numberOfSal.length*filmDivHeight+'px',top: '75px'}}>
     {numberOfSal.sort(function (a,b) { 
          if (a.UseSeats !== b.UseSeats) {
           return b.UseSeats - a.UseSeats
        }
        if (a.name === b.name) {
         return 0;
        }
        return a.name > b.name ? 1 : -1
         } ).map((sal) => (
       <p key={sal.No} className='sal' style={{height:filmDivHeight+'px'}}>{sal.name}</p>
     ))}
      
   </div>
       
      {allEvents.length ?   <p className='twelve' style={{backgroundColor:modalShown?'':'#fff',paddingTop:'0px',color:modalShown?'#524f4f':'#8d8d8d'}}>  
               <span className='twelve' style={{color:'#8d8d8d',fontSize:'12px'}}>{te}:00</span> 
                </p> 
              : ''  }
        <table className='table table-bordered'   id={"program_table"+show_index} style={{
          // width:'1573px',
          position:'relative'}} >
          
         { isloading === false && 
         <>
           <thead id={'t_head'+show_index}>
             <tr style={{height:'52px',borderBottom:'1px solid #dee0e3',}}>
             {timeStamp.map((t, i) => (
                    <td  key={i} className='formattedTD' style={{position:'relative',borderLeft: t[0] ? '1px solid lightgrey' : ''}}>
                        <span style={{position:'absolute',top:'0px',left:'-21px',fontSize:'12px',paddingTop:'28px'}}>
                         {t == '24' ? '00' : t == '25' ? '01' : t == '26' ? '02'  : t}:00</span>
                   </td>
             )
             )}                      
             </tr>      
           </thead>
                
          </>
       }
         <tbody id={'t_body'+show_index} >
           {numberOfSal.map((sal,index) => (
            <tr className='table_row' style={{height:filmDivHeight+'px'}}>
              {timeStamp.map((t,i) => (
               <td key={i} style={{borderLeft: t[0] ? '1px solid lightgrey' : ''}}></td>
              ))}         
            </tr>        
           ))}     
         </tbody>
    
        {showG === true && ('t_body'+show_index === chosenTableNo) ?
       
         <div  style={{position:'absolute',top:`${y}px`,left:`${x}px`,height:'45px',  color:'white' }}> 
           <span style={{position:'absolute', top:'-15px',fontSize:'12px',color:'#46484c'}}>{moment(startTime).format('HH:mm')}</span>
         <div  id={'t_body'+show_index} style={{height:filmDivHeight+'px', 
         background:newDraggedFilm.length === 0 ? 'linear-gradient(to right, #982f2f, transparent)': '#982f2f',
         width:`${(pixelWidthPerMin*filmWidth).toString().split(".")[0] + 'px'}`,zIndex:9 ,color:'white',alignItems:'center' }}>{draggedFilm}</div>     
         </div>     
          : ''
           }  
    
      
       {program}
        
   
        </table>
       
                   </div> 
                   </div>
  )
}

export default ProgramTable